import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import i18nMessages from './SideMenuTranslations';
import { AccountType } from '../../../shared/Constants';

const OrganisationManagementSideMenuBuilder = (accountId, accountType) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const buildAddClientTab = () => {
    const addClientAccount = {
      label: formatMessage(i18nMessages.addClientAccount),
      icon: 'pi pi-plus-circle',
      command: () => {
        const url = `/accounts/${accountId}/accounts/add-client`;
        history.push(url);
      },
    };

    return addClientAccount;
  };

  const buildAddCPAccountTab = () => {
    const addCPAccount = {
      label: formatMessage(i18nMessages.addCPAccount),
      icon: 'pi pi-plus-circle',
      command: () => {
        const url = `/accounts/${accountId}/accounts/add-cp`;
        history.push(url);
      },
    };

    return addCPAccount;
  };

  const builAddMCPAccountTab = () => {
    const addMCPAccount = {
      label: formatMessage(i18nMessages.addMCPAccount),
      icon: 'pi pi-plus-circle',
      command: () => {
        const url = `/accounts/${accountId}/accounts/add-mcp`;
        history.push(url);
      },
    };

    return addMCPAccount;
  };

  const buildAddNBMClientTab = () => {
    const addNBMClientAccount = {
      label: formatMessage(i18nMessages.addClientAccount),
      icon: 'pi pi-plus-circle',
      command: () => {
        const url = `/accounts/${accountId}/accounts/add-nbm-client`;
        history.push(url);
      },
    };

    return addNBMClientAccount;
  };

  // const buildCreateEssentialAccountInvitationTab = () => {
  //   const addNBMClientAccount = {
  //     label: "Add Essential Account",
  //     icon: 'pi pi-plus-circle',
  //     command: () => {
  //       const url = `/accounts/${accountId}/accounts/add-essential`;
  //       history.push(url);
  //     },
  //   };

  //   return addNBMClientAccount;
  // };

  const buildInviteNewClientTab = () => {
    return {
      label: formatMessage(i18nMessages.inviteNewClient),
      icon: 'pi pi-plus-circle',
      command: () => {
        const url = `/accounts/${accountId}/accounts/add-nbm-client`;
        history.push(url);
      },
    };
  };

  const buildAddGSCAccountTab = () => {
    const addGSCAccount = {
      label: formatMessage(i18nMessages.addGSCAccount),
      icon: 'pi pi-plus-circle',
      command: () => {
        const url = `/accounts/${accountId}/accounts/add-gsc`;
        history.push(url);
      },
    };

    return addGSCAccount;
  };

  const buildAddGPAccountTab = () => {
    const addGPAccount = {
      label: formatMessage(i18nMessages.addGPAccount),
      icon: 'pi pi-plus-circle',
      command: () => {
        const url = `/accounts/${accountId}/accounts/add-gp`;
        history.push(url);
      },
    };

    return addGPAccount;
  };

  const buildInvitationTab = () => {
    const listInvitations = {
      label: formatMessage(i18nMessages.listInvitations),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/accounts/invitations`;
        history.push(url);
      },
    };

    return listInvitations;
  };

  const buildListOrganisationTab = () => {
    const listOrganisation = {
      label: formatMessage(i18nMessages.listOrganisation),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/accounts/organisation-accounts`;
        history.push(url);
      },
    };

    return listOrganisation;
  };

  const buildUpdateDimensionsTab = () => {
    const updateDimensions = {
      label: formatMessage(i18nMessages.updateDimensions),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/accounts/update-dimensions`;
        history.push(url);
      },
    };

    return updateDimensions;
  };

  const buildOrganisationManagementTabs = () => {
    const organisationManagementItems = [];

    const addClientAccount = buildAddClientTab();
    const addNBMClientAccount = buildAddNBMClientTab();
    // const createEssentialAccountInvitation = buildCreateEssentialAccountInvitationTab();
    const addCPAccount = buildAddCPAccountTab();
    const addMCPAccount = builAddMCPAccountTab();
    const addGSCAccount = buildAddGSCAccountTab();
    const addGPAccount = buildAddGPAccountTab();
    const listInvitations = buildInvitationTab();
    const listOrganisation = buildListOrganisationTab();
    const updateDimensions = buildUpdateDimensionsTab();

    if (accountType === AccountType.CP) {
      organisationManagementItems.push(addClientAccount);
      organisationManagementItems.push(listInvitations);
      organisationManagementItems.push(listOrganisation);
      organisationManagementItems.push(updateDimensions);
    } else if (accountType === AccountType.MCP) {
      organisationManagementItems.push(addClientAccount);
      organisationManagementItems.push(addCPAccount);
      organisationManagementItems.push(listInvitations);
      organisationManagementItems.push(listOrganisation);
      organisationManagementItems.push(updateDimensions);
    } else if (accountType === AccountType.GSC) {
      organisationManagementItems.push(addNBMClientAccount);
      // organisationManagementItems.push(createEssentialAccountInvitation);
      organisationManagementItems.push(addGPAccount);
      organisationManagementItems.push(listInvitations);
      organisationManagementItems.push(listOrganisation);
      organisationManagementItems.push(updateDimensions);
    } else if (accountType === AccountType.GP) {
      organisationManagementItems.push(addNBMClientAccount);
      // organisationManagementItems.push(createEssentialAccountInvitation);
      organisationManagementItems.push(listInvitations);
      organisationManagementItems.push(listOrganisation);
      organisationManagementItems.push(updateDimensions);
    } else if (accountType === AccountType.GPI) {
      organisationManagementItems.push(addClientAccount);
      organisationManagementItems.push(addCPAccount);
      organisationManagementItems.push(addMCPAccount);
      organisationManagementItems.push(addNBMClientAccount);
      organisationManagementItems.push(addGPAccount);
      organisationManagementItems.push(addGSCAccount);
      organisationManagementItems.push(listInvitations);
      organisationManagementItems.push(listOrganisation);
      organisationManagementItems.push(updateDimensions);
    }

    return organisationManagementItems;
  };

  const buildOrganisationManagementOverviewItems = () => {
    const listInvitations = buildInvitationTab();
    const listOrganisation = buildListOrganisationTab();
    const updateDimensions = buildUpdateDimensionsTab();

    return [listInvitations, listOrganisation, updateDimensions];
  };

  const buildTransferCreditsTab = () => {
    const transferCredits = {
      label: formatMessage(i18nMessages.transferCredits),
      icon: 'pi pi-refresh',
      command: () => {
        const url = `/accounts/${accountId}/organisation-transfers/new`;
        history.push(url);
      },
    };

    return transferCredits;
  };

  const buildTransferTabs = () => {
    const transferLog = {
      label: formatMessage(i18nMessages.transferLog),
      icon: 'pi pi-align-left',
      command: () => {
        const url = `/accounts/${accountId}/organisation-transfers`;
        history.push(url);
      },
    };

    return transferLog;
  };

  const buildTransferDemoCreditsTab = () => {
    const transferDemoCredits = {
      label: formatMessage(i18nMessages.transferDemoCredits),
      icon: 'pi pi-refresh',
      command: () => {
        const url = `/accounts/${accountId}/demo-transfers/new`;
        history.push(url);
      },
    };

    return transferDemoCredits;
  };

  const buildDemoCreditsLogTab = () => {
    const demoCreditsLog = {
      label: formatMessage(i18nMessages.demoCreditsLog),
      icon: 'pi pi-align-left',
      command: () => {
        const url = `/accounts/${accountId}/demo-transfers`;
        history.push(url);
      },
    };

    return demoCreditsLog;
  };

  const buildCreditPlanTab = () => {
    const creditPlans = {
      label: formatMessage(i18nMessages.creditPlans),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/credit-plans`;
        history.push(url);
      },
    };

    return creditPlans;
  };

  const buildManageNoLimitPaidByMeTab = () => {
    return {
      label: formatMessage(i18nMessages.manageNoLimitPaidByMe),
      icon: 'pi pi-briefcase',
      command: () => {
        const url = `/accounts/${accountId}/manage-accounts`;
        history.push(url);
      },
    };
  };

  const buildReactivateNoLimitPaidByMe = () => {
    const buyOrReactivate = {
      label: formatMessage(i18nMessages.reactivateNoLimitPaidByMe),
      icon: 'pi pi-check',
      command: () => {
        const url = `/accounts/${accountId}/buy-or-reactivate`;
        history.push(url);
      },
    };

    return buyOrReactivate;
  };

  const buildNoLimitInvoicesPaidByMe = () => {
    return {
      label: formatMessage(i18nMessages.noLimitInvoicesPaidByMe),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/organisation-invoices`;
        history.push(url);
      },
    };
  };

  const buildAgreedCommissionTab = () => {
    const agreedCommission = {
      label: formatMessage(i18nMessages.agreedCommission),
      icon: 'pi pi-briefcase',
      command: () => {
        const url = `/accounts/${accountId}/agreed-commissions`;
        history.push(url);
      },
    };

    return agreedCommission;
  };

  const buildSettledCommissionTab = () => {
    const settledCommission = {
      label: formatMessage(i18nMessages.settledCommission),
      icon: 'pi pi-briefcase',
      command: () => {
        const url = `/accounts/${accountId}/settled-commission`;
        history.push(url);
      },
    };

    return settledCommission;
  };

  const buildInvoiceCommissionTab = () => {
    const invoiceCommission = {
      label: formatMessage(i18nMessages.invoiceCommission),
      icon: 'pi pi-briefcase',
      command: () => {
        const url = `/accounts/${accountId}/invoice-commission`;
        history.push(url);
      },
    };

    return invoiceCommission;
  };

  const buildOrganisationManagementCreditTabs = () => {
    const organisationManagementCreditItems = [];

    const transferCredits = buildTransferCreditsTab();
    const transferLog = buildTransferTabs();
    const transferDemoCredits = buildTransferDemoCreditsTab();
    const demoCreditsLog = buildDemoCreditsLogTab();
    const creditPlans = buildCreditPlanTab();

    if (accountType === AccountType.CP || accountType === AccountType.GP) {
      organisationManagementCreditItems.push(transferCredits);
      organisationManagementCreditItems.push(transferLog);
    } else if (accountType === AccountType.MCP || accountType === AccountType.GSC) {
      organisationManagementCreditItems.push(transferCredits);
      organisationManagementCreditItems.push(transferLog);
      organisationManagementCreditItems.push(transferDemoCredits);
      organisationManagementCreditItems.push(demoCreditsLog);
    } else if (accountType === AccountType.GPI) {
      organisationManagementCreditItems.push(transferCredits);
      organisationManagementCreditItems.push(transferLog);
      organisationManagementCreditItems.push(transferDemoCredits);
      organisationManagementCreditItems.push(demoCreditsLog);
      organisationManagementCreditItems.push(creditPlans);
    }

    return organisationManagementCreditItems;
  };

  const buildOrganisationManagementBusinessCenterItems = () => {
    const clientsItems = buildClientsItems();
    const gpiPartnerItems = buildGpiPartnerItems();
    const commissionItems = buildCommissionItems();

    const clients = {
      label: formatMessage(i18nMessages.clients),
      icon: 'pi pi-briefcase',
      items: clientsItems,
    };

    const gpiPartners = {
      label: formatMessage(i18nMessages.gpiPartners),
      icon: 'pi pi-briefcase',
      items: gpiPartnerItems,
    };

    const commission = {
      label: formatMessage(i18nMessages.commission),
      icon: 'pi pi-briefcase',
      items: commissionItems,
    };

    const businessCenterItems = [];

    if (accountType === AccountType.GSC) {
      businessCenterItems.push(clients);
      businessCenterItems.push(gpiPartners);
      businessCenterItems.push(commission);
    }

    if (accountType === AccountType.GP) {
      businessCenterItems.push(clients);
      businessCenterItems.push(commission);
    }

    return businessCenterItems;
  };

  const buildClientsItems = () => {
    const inviteNewClientTab = buildInviteNewClientTab();
    // const createEssentialAccountInvitation = buildCreateEssentialAccountInvitationTab();
    const manageNoLimitPaidByMe = buildManageNoLimitPaidByMeTab();
    const reactivateNoLimitPaidByMe = buildReactivateNoLimitPaidByMe();
    const noLimitInvoicesPaidByMe = buildNoLimitInvoicesPaidByMe();

    // const items = [inviteNewClientTab, createEssentialAccountInvitation];
    const items = [inviteNewClientTab];

    if (accountType === AccountType.GSC) {
      items.push(manageNoLimitPaidByMe);
      items.push(reactivateNoLimitPaidByMe);
      items.push(noLimitInvoicesPaidByMe);
    }

    return items;
  };

  const buildGpiPartnerItems = () => {
    const inviteNewGpiPartnerTab = buildInviteNewGpiPartnerTab();
    const agreedCommission = buildAgreedCommissionTab();

    return [inviteNewGpiPartnerTab, agreedCommission];
  };

  const buildCommissionItems = () => {
    const invoiceCommission = buildInvoiceCommissionTab();
    const settledCommission = buildSettledCommissionTab();

    return [invoiceCommission, settledCommission];
  };

  const buildInviteNewGpiPartnerTab = () => {
    return {
      label: formatMessage(i18nMessages.inviteNewGpiPartner),
      icon: 'pi pi-plus-circle',
      command: () => {
        const url = `/accounts/${accountId}/accounts/add-gp`;
        history.push(url);
      },
    };
  };

  const buildOrganisationSideMenu = () => {
    const organisationManagementItems = buildOrganisationManagementTabs();
    const organisationManagementCreditItems = buildOrganisationManagementCreditTabs();
    const organisationManagementOverviewItems = buildOrganisationManagementOverviewItems();
    const organisationManagementBusinessCenterItems = buildOrganisationManagementBusinessCenterItems();

    const accuntIsGpiOrOldBussinessModel =
      accountType === AccountType.GPI ||
      accountType === AccountType.CLIENT ||
      accountType === AccountType.CP ||
      accountType === AccountType.MCP;

    const accountIsGscOrGp = accountType === AccountType.GSC || accountType === AccountType.GP;

    if (accuntIsGpiOrOldBussinessModel) {
      return {
        label: formatMessage(i18nMessages.organisationManagement),
        icon: 'pi pi-table',
        items: [
          {
            label: formatMessage(i18nMessages.accounts),
            icon: 'pi pi-th-large',
            items: organisationManagementItems,
          },
          {
            label: formatMessage(i18nMessages.creditsManagement),
            icon: 'pi pi-briefcase',
            items: organisationManagementCreditItems,
          },
        ],
      };
    }

    if (accountIsGscOrGp) {
      return {
        label: formatMessage(i18nMessages.organisationManagement),
        icon: 'pi pi-table',
        items: [
          {
            label: formatMessage(i18nMessages.overview),
            icon: 'pi pi-th-large',
            items: organisationManagementOverviewItems,
          },
          {
            label: formatMessage(i18nMessages.businessCenter),
            icon: 'pi pi-dollar',
            items: organisationManagementBusinessCenterItems,
          },
        ],
      };
    }

    return {
      label: formatMessage(i18nMessages.organisationManagement),
      icon: 'pi pi-table',
      items: [],
    };
  };

  return {
    buildOrganisationSideMenu,
  };
};

export default OrganisationManagementSideMenuBuilder;
